/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRichContactRequest } from './APIRichContactRequest';
import {
    APIRichContactRequestFromJSON,
    APIRichContactRequestFromJSONTyped,
    APIRichContactRequestToJSON,
} from './APIRichContactRequest';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIContactGroupViewRequest
 */
export interface APIContactGroupViewRequest {
    /**
     * 
     * @type {Array<APIRichContactRequest>}
     * @memberof APIContactGroupViewRequest
     */
    contacts: Array<APIRichContactRequest>;
    /**
     * 
     * @type {string}
     * @memberof APIContactGroupViewRequest
     */
    name: string;
}

/**
 * Check if a given object implements the APIContactGroupViewRequest interface.
 */
export function instanceOfAPIContactGroupViewRequest(value: object): value is APIContactGroupViewRequest {
    if (!('contacts' in value) || value['contacts'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIContactGroupViewRequestFromJSON(json: any): APIContactGroupViewRequest {
    return APIContactGroupViewRequestFromJSONTyped(json, false);
}

export function APIContactGroupViewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContactGroupViewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contacts': ((json['contacts'] as Array<any>).map(APIRichContactRequestFromJSON)),
        'name': json['name'],
    };
}

export function APIContactGroupViewRequestToJSON(value?: APIContactGroupViewRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contacts': ((value['contacts'] as Array<any>).map(APIRichContactRequestToJSON)),
        'name': value['name'],
    };
}

